<template>
  <section id="contact">
    <h1>联系我们</h1>
    <p class="contact-intro">欢迎联系关键包装，咨询食品与餐饮行业的包材定制需求。无论是新品开发、门店开业、包装升级或日常补货，我们都希望为您提供更合适的方案。</p>
    <div class="contact-container">
      <div class="contact-info">
        <h3>{{ contactCompanyName }}</h3>
        <div class="info-item" v-if="contactAddress">
          <i class="fas fa-map-marker-alt"></i>
          <p>地址：{{ contactAddress }}</p>
        </div>
        <div class="info-item" v-if="contactPhone">
          <i class="fas fa-phone"></i>
          <p>电话：{{ contactPhone }}</p>
        </div>
        <div class="info-item" v-if="contactEmail">
          <i class="fas fa-envelope"></i>
          <p>邮箱：{{ contactEmail }}</p>
        </div>
        <div class="info-item" v-if="contactHours">
          <i class="fas fa-clock"></i>
          <p>工作时间：{{ contactHours }}</p>
        </div>
      </div>
      <div class="contact-form">
        <h3>留言咨询</h3>
        <form @submit.prevent="submitForm">
          <div class="form-container">
            <div class="form-group">
              <label for="name">您的姓名</label>
              <input type="text" id="name" v-model="form.name" required placeholder="请输入您的姓名">
            </div>
            <div class="form-group">
              <label for="email">邮箱地址</label>
              <input type="email" id="email" v-model="form.email" required placeholder="请输入您的邮箱地址">
            </div>
            <div class="form-group">
              <label for="phone">联系电话</label>
              <input type="tel" id="phone" v-model="form.phone" placeholder="请输入您的联系电话">
            </div>
            <div class="form-group">
              <label for="subject">咨询主题</label>
              <select id="subject" v-model="form.subject" required>
                <option value="" disabled selected>请选择咨询主题</option>
                <option v-for="(option, index) in subjectOptions" :key="index" :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="message">留言内容</label>
              <textarea id="message" v-model="form.message" required placeholder="请详细描述您的需求，我们会尽快回复您"></textarea>
            </div>
            <div class="form-btn-group">
              <button type="submit" class="submit-btn" :disabled="submitting">
                {{ submitting ? '提交中...' : '提交留言' }}
              </button>
            </div>
            <div v-if="formMessage" :class="['form-message', formStatus]">
              {{ formMessage }}
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import apiBaseUrl from '@/config/api.js';
import { getWebsiteContent } from '@/api/websiteContent.js';

export default {
  name: 'ContactView',
  data() {
    return {
      contactCompanyName: '关键包装（KeyPoint Pack）',
      contactAddress: '上海市宝山区罗泾镇银石路288号',
      contactPhone: '+86 13636360548',
      contactEmail: '2302137948@qq.com',
      contactHours: '周一至周六 9:00-18:00',
      form: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      subjectOptions: [
        '产品咨询',
        '定制服务',
        '合作洽谈',
        '投诉建议',
        '其他问题'
      ],
      submitting: false,
      formMessage: '',
      formStatus: ''
    }
  },
  mounted() {
    console.log('[联系我们] 页面已加载，展示联系说明文案');
    getWebsiteContent()
      .then((data) => {
        const s = data.settings || {};
        if (s.company_name) this.contactCompanyName = s.company_name;
        if (s.contact_address) this.contactAddress = s.contact_address;
        if (s.contact_phone) this.contactPhone = s.contact_phone;
        if (s.contact_email) this.contactEmail = s.contact_email;
        if (s.contact_hours) this.contactHours = s.contact_hours;
      })
      .catch(() => {});
  },
  methods: {
    async submitForm() {
      // 表单验证
      if (!this.form.name || !this.form.email || !this.form.subject || !this.form.message) {
        this.formStatus = 'error';
        this.formMessage = '请填写所有必填字段。';
        return;
      }
      
      this.submitting = true;
      this.formMessage = '';
      
      console.log('[联系表单] 开始提交表单数据:', this.form);
      
      try {
        console.log('[联系表单] 发送请求到:', `${apiBaseUrl}/api/contact`);

        const response = await axios.post(`${apiBaseUrl}/api/contact`, this.form);
        
        console.log('[联系表单] 服务器响应:', response.data);
        
        if (response.data.success) {
        this.formStatus = 'success';
          this.formMessage = response.data.message || '感谢您的留言，我们会尽快与您联系！';
        
        // 清空表单
        this.form = {
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        };
        } else {
          this.formStatus = 'error';
          this.formMessage = response.data.message || '提交失败，请稍后再试。';
        }
      } catch (error) {
        console.error('[联系表单] 提交失败:', error);
        
        // 处理不同类型的错误
        if (error.response) {
          // 服务器返回了错误响应
          const errorMessage = error.response.data?.message || error.response.data?.error || '服务器错误';
          console.error('[联系表单] 服务器错误响应:', error.response.data);
          this.formStatus = 'error';
          this.formMessage = errorMessage;
        } else if (error.request) {
          // 请求已发送但没有收到响应（可能是网络问题或服务器未启动）
          console.error('[联系表单] 网络错误: 无法连接到服务器');
          this.formStatus = 'error';
          this.formMessage = '无法连接到服务器，请检查网络连接或联系管理员。';
        } else {
          // 其他错误
          console.error('[联系表单] 请求配置错误:', error.message);
        this.formStatus = 'error';
          this.formMessage = `提交失败: ${error.message}`;
        }
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
section {
  min-height: auto;
  padding: 20px 0 60px 0; /* 与 AboutView 保持一致的高度，上方 20px，下方 60px */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.contact-container {
  width: 80%;
  max-width: 1200px;
  margin: 40px auto 0;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
}

.contact-info, .contact-form {
  flex: 1 1 400px;
  background: #222;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  text-align: left;
}

#contact h1 {
  font-size: 2rem;
  margin-bottom: 0.8rem;
  color: white;
}

.contact-intro {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: white;
  text-align: center;
  max-width: 90%;
  line-height: 1.5;
}

.contact-info h3, .contact-form h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: white;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #ddd;
}

.info-item i {
  font-size: 20px;
  color: #e50914;
  margin-right: 15px;
  width: 25px;
  text-align: center;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* 表单样式 */
.form-group {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #ddd;
  font-weight: 500;
  align-self: flex-start;
  margin-left: 7.5%;
}

.form-group input, 
.form-group select {
  width: 85%;
  padding: 12px 15px;
  background: #333;
  border: 1px solid #444;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  transition: all 0.2s;
  align-self: center;
}

.form-group textarea {
  width: 85%;
  padding: 12px 15px;
  background: #333;
  border: 1px solid #444;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  transition: all 0.2s;
  height: 150px;
  resize: vertical;
  align-self: center;
}

.form-group input:focus, 
.form-group select:focus, 
.form-group textarea:focus {
  outline: none;
  border-color: #e50914;
  box-shadow: 0 0 0 2px rgba(229, 9, 20, 0.2);
}

.form-btn-group {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.submit-btn {
  width: 85%;
  padding: 12px;
  background: #e50914;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.3s;
}

.submit-btn:hover {
  background: #ff1a25;
}

.submit-btn:disabled {
  background: #666;
  cursor: not-allowed;
}

.form-message {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  width: 85%;
}

.form-message.success {
  background: rgba(76, 175, 80, 0.1);
  color: #4CAF50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.form-message.error {
  background: rgba(244, 67, 54, 0.1);
  color: #F44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    width: 90%;
  }
  
  .contact-info, .contact-form {
    width: 100%;
  }
  
  .form-group label {
    margin-left: 5%;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 90%;
  }
  
  .form-btn-group {
    width: 90%;
  }
  
  .submit-btn {
    width: 100%;
  }
  
  .form-message {
    width: 90%;
  }
}

@media (max-width: 480px) {
  .form-group label {
    margin-left: 5%;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea,
  .form-message {
    width: 90%;
  }
}
</style> 